<template>
  <div class="header-wrapper">
    <div class="header">
      <div class="header-left">
        <div class="left-top" @click="handleMenuClick">
          <!-- {{ systemConfig.title }} -->
          <!-- 特教Ai康复云平台 -->
          {{ title }}
        </div>
      </div>
      <div class="header-right">
        <div v-for="(item, index) in navItems" :key="index" class="nav-item" :class="{ active: isMenuActive(item) }">
          <a-dropdown v-if="item.list && item.list.length">
            <div class="nav-content" @click="handleNavClick(item)">
              <div class="nav-icon" v-if="item.icon && item.icon != ''">
                <img :src="require(`@/assets/image/nav/` + item.icon + `.png`)" alt="">
              </div>
              <span>{{ item.name }}</span>
            </div>
            <template #overlay>
              <a-menu style="text-align:center">
                <a-menu-item v-for="child in item.list" :key="child.url" @click="handleNavClick(child)">
                  <span class="menu-item">{{ child.name }}</span>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>


          <div v-else class="nav-content" @click="handleNavClick(item)">
            <div class="nav-icon" v-if="item.icon && item.icon != ''">
              <img :src="require(`@/assets/image/nav/` + item.icon + `.png`)" alt="">
            </div>
            <span class="menu-item">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from 'ant-design-vue'
// import { message } from 'ant-design-vue'
import { getMenuNav } from '@/api/user'
// import { systemConfig } from '@/config/system'
import { useRouter } from 'vue-router'

export default {
  name: 'Header',
  // props: ['title',],
  components: {
    [Tabs.name]: Tabs,
    [Tabs.TabPane.name]: Tabs.TabPane,
  },
  data() {
    return {
      activeKey: '1',
      navItems: [],
      router: useRouter(),
      title: ''
    }
  },

  computed: {
    // systemConfig() {
    //   return systemConfig
    // },
    currentPath() {
      return this.$route.path
    },
    isMenuActive() {
      return (item) => {
        // 如果是一级菜单且有子菜单，检查当前路径是否匹配子菜单
        if (item.list && item.list.length) {
          return item.list.some(child => this.currentPath === child.url)
        }
        // 如果是没有子菜单的一级菜单，精确匹配路径
        return this.currentPath.includes(item.url)
      }
    }
  },

  created() {
    this.getNavData()
    this.getTitle()
  },

  methods: {
    handleNavClick(item) {
      // 如果是一级菜单且有子菜单，不进行路由跳转
      if (item.list && item.list.length) {
        return
      }
      if (this.currentPath !== item.url) {
        this.router.push(item.url)
      }
    },


    // 获取导航数据
    async getNavData() {
      // try {
      const res = await getMenuNav()  // 使用正确的接口函数名
      if (res.code === 200) {

        this.navItems = res.data
      }
      // } catch (error) {
      //   console.error('获取导航菜单错误：', error)
      //   message.error('获取导航菜单失败')
      // }
    },

    handleMenuClick() {
      this.router.push('/index')
    },
    getTitle() {
      // console.log(this.title, 'props.title');

      // console.log(localStorage.getItem("title"), 'localStorage.getItem("title")');

      this.title = localStorage.getItem("title");
    }

  }
}
</script>


<style lang="less" scoped>
.header-wrapper {

  .header {
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    color: #fff;
    // background: url(http://localhost:8080/img/bj.98c9c680.png) no-repeat 100%;
    background: url('/src/assets/image/nav/bj.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    overflow: hidden;
  }

  .sub-nav {
    padding: 0 24px;
    background: rgba(255, 255, 255, 0.1);

    :deep(.ant-tabs) {
      .ant-tabs-nav {
        margin: 0;
        padding: 0 16px 0px;

        &::before {
          border: none;
        }

      }

      .ant-tabs-tab {
        padding: 12px 0;
        color: rgba(255, 255, 255, 0.8);
        margin: 0 32px 0 0;

        &:hover {
          color: #fff;
        }
      }

      .ant-tabs-tab-active {
        .ant-tabs-tab-btn {
          color: #fff;
        }
      }

      .ant-tabs-ink-bar {
        background: #fff;
      }
    }


  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-direction: column;
    align-items: flex-start;

    padding-left: 10px;
    letter-spacing: 2px;
    align-items: flex-start;
    height: 100%;
    padding-top: 8px;

    .left-top {
      font-size: 32px;
      text-shadow: 0px 3px 5px rgba(24, 89, 255, 0.35);
      cursor: pointer;
      position: absolute;
      left: 20px;
    }


    .left-user {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      padding-left: 5%;
    }

    .avatar {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      margin-right: 10px
    }

    .role {
      font-size: 22px;
      font-weight: 500;
      cursor: pointer;
    }
  }

  .header-right {
    display: flex;

    .nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s;
      position: relative;

      .nav-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 4px 15px;
        font-size: 20px;

        .menu-item {
          font-size: 12px;
          padding: 0 5px;
        }

      }



      &.active {
        .nav-content {
          transition: all 0.3s;
          background: url('/src/assets/image/nav/active-bj.png') no-repeat center bottom;
          background-size: 100% 100%;
        }

        // .nav-icon {
        //   background: rgba(255, 255, 255, 0.3); // 修改激活背景色
        //   transform: scale(1.1); // 添加轻微放大效果
        // }

        // span {
        //   font-weight: bold; // 文字加粗
        //   text-shadow: 0 0 10px rgba(255, 255, 255, 0.5); // 添加文字光晕
        // }
      }

      .nav-icon {
        width: 33px;
        height: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        color: #fff;

        img {
          width: 100%;
          height: 100%;
        }
      }

      span {
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 2px;
      }

    }
  }
}

// 修改下拉菜单样式，提高选择器优先级
:deep(.ant-dropdown) {
  .ant-dropdown-menu {
    min-width: 200px; // 增加宽度以适应更大的字体

    .ant-dropdown-menu-item {
      min-height: 60px; // 增加高度
      padding: 16px 24px; // 增加内边距
      font-size: 26px !important; // 增加字体大小

      span {
        font-size: 26px !important; // 确保 span 内的文字也变大
      }

      &:hover {
        background: #F5F8FF !important;
        color: #5E8BFF !important;
      }
    }
  }
}

// 用户下拉菜单样式也相应调整
:deep(.ant-dropdown .ant-dropdown-menu) {
  .ant-dropdown-menu-item {
    min-height: 60px;
    padding: 16px 24px;
    font-size: 26px !important;

    .anticon {
      font-size: 24px;
      margin-right: 12px;
    }

    span {
      font-size: 26px !important;
    }
  }
}

:deep(.ant-dropdown .ant-menu) {
  .ant-menu-item {
    height: auto !important;
    line-height: normal !important;
    padding: 16px 24px !important;

    * {
      font-size: 26px !important;
    }
  }
}

:deep(.ant-dropdown-menu) {
  .ant-dropdown-menu-item {
    height: auto !important;
    line-height: normal !important;
    padding: 16px 24px !important;

    * {
      font-size: 26px !important;
    }
  }
}

@media (min-width: 1921px) {
  .header {
    height: 164px !important;
  }

  .left-top {
    font-size: 50px !important;
    padding: 4px 40px !important;
  }

  .nav-item {
    .nav-icon {
      width: 66px !important;
      height: 66px !important;
    }

    span {
      font-size: 20px !important;
      text-align: center !important;
      padding: 0 18px !important;
    }
  }

  .menu-item {
    font-size: 16px !important;
  }

  :deep(.ant-tabs) {
    .ant-tabs-nav {
      padding: none !important;
    }
  }
}
</style>